export default {"src":"/_next/static/media/testconnaissance.90aeb895.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};